import { combineReducers } from 'redux';

import { shipmentsFilterReducer, namespace as filteringNamespace } from './filtering/shipments.filtering.reducer';
import { shipmentsGrid, namespace as gridNamespace } from './grid/shipments.grid.reducer';
import { ConnectedActionHandlerMap as navReducer, namespace as navNamespace } from './nav/shipments.nav.reducer';
import {
  reduce as selectedShipmentsReducer,
  namespace as selectedShipmentsNamespace,
} from './selected-shipments/shipments.selected-shipments.reducer';
import { shipmentDetails, namespace as shipmentDetailsNamespace } from './shipment-details/shipments.details.reducer';
import { shipmentsEOD, namespace as eodShipmentsNamespace } from './eod/shipments.eod.reducer';

export const combinedReducer = combineReducers({
  [filteringNamespace]: shipmentsFilterReducer,
  [gridNamespace]: shipmentsGrid,
  [navNamespace]: navReducer,
  [selectedShipmentsNamespace]: selectedShipmentsReducer,
  [shipmentDetailsNamespace]: shipmentDetails,
  [eodShipmentsNamespace]: shipmentsEOD,
});

export { namespace } from './shipments.reducer.metadata';
